// 依赖 mixin/index.js

import {
  LEAVE_ROLE,
  TAB_ROLE_ID,
  MODULE_ROLE_TYPE,
  ROLE_REPLACE_TYPE
} from '@/utils/constUtils'
import { setItem, getHash, getPageTitle } from '@/utils/comUtils'
export default {
  data() {
    return {
      // 混入引入 项目里面就不需要再引入了
      HeadmasterRole: LEAVE_ROLE.headmaster,
      adminRole: LEAVE_ROLE.admin,
      customRole: LEAVE_ROLE.customRole,
      currentModule: '',
      headerTabList: [],
      headerTabId: 0 // String | Number
    }
  },
  created() {
    this.verifyMixin()
  },
  computed: {
    // 当前显示的是否为自定义界面
    isAdminPage() {
      return [LEAVE_ROLE.admin, LEAVE_ROLE.customRole].includes(
        +this.headerTabId
      )
    },
    // 当前显示的是否为班主任界面
    isHeadmasterPage() {
      return [LEAVE_ROLE.headmaster].includes(+this.headerTabId)
    },
    // 自定义界面界面是不是仅仅是自定义角色
    isAdminPageOnlyCustom() {
      return this.isAdminPage && +this.headerTabId === LEAVE_ROLE.customRole
    }
  },
  watch: {
    headerTabId(newValue) {
      // 开发环境禁止增加 loading
      if (!['attendance', 'leave'].includes(this.currentModule)) {
        let showLoading = this.$Toast({
          type: 'loading',
          duration: 9000,
          content: '加载中'
        }).show()
        setTimeout(() => {
          try {
            showLoading && showLoading.hide()
          } catch (error) {}
        }, 300)
      }

      this.setLocalRoleId(newValue)
    }
  },
  methods: {
    verifyMixin() {
      if (!this.mixinRouter) {
        throw new Error('roleTab 依赖 mixin/index.js，请先引入！')
      }
    },
    /**
     * 获取 tab 列表
     * @param {String} module 对应的模块名 对应 allModuleMap 字段
     * @param {String,Number} defaultTabId 默认的角色 ID
     * @param {String} isGray 是否是灰度
     */
    createHeaderTab(module, defaultTabId, isGray) {
      this.headerTabList = new CreateTab(this, module, isGray).getTabList()
      this.currentModule = module
      this.turnHeaderTabList()
      this.initHeaderTabId(defaultTabId)
      // 模块角色合并
      this.setModuleRoleType()
      // 如果引用且没有 tab
      if (!this.headerTabList.length && this.curIsTeacher) {
        this.$router.replace({
          path: '/access',
          query: {
            name: getPageTitle(this.$route)
          }
        })
      }
    },
    initHeaderTabId(defaultTabId) {
      if (!this.headerTabList.length) {
        return
      }
      // 存在并校验是否在列表中
      if (
        defaultTabId &&
        this.headerTabList.find(item => item.id === defaultTabId)
      ) {
        this.headerTabId = defaultTabId
        return
      }
      this.headerTabId = this.headerTabList[0].id
    },
    // 对返回的 tab 列表进行一些转化
    turnHeaderTabList() {
      // 通知公告将全部班级、我的班级转化为 全部、我的
      if (this.currentModule !== 'welcome' || !this.headerTabList.length) return
      this.headerTabList = this.headerTabList.map(item => {
        return {
          ...item,
          name: `${item.name}`.replace(/班级/g, '')
        }
      })
    },
    // 对于一些没有 tab 的,可以进行数据的处理
    setLocalRoleId(id) {
      setItem(TAB_ROLE_ID, {
        role: id || 0
      })
    },
    // 判断当前模块权限合并属于哪种情况，并记录该模块的首页地址
    setModuleRoleType() {
      // note: 该缓存依赖 TAB_ROLE_ID，无需删除处理
      // 首页的角色不会被替换
      // 在请求中只会处理为 all 的情况
      if (this.curIsTeacher) {
        // 有些模块详情与首页的角色是绑定的，不能替换（学生考勤、学生宿舍、课堂评价）
        // 部分模块是合并角色有问题 先保持不变（学生荣誉、学生请假）
        // 有些模块是替换与否均可，保持上一版本。我宁愿什么都不做也不愿犯错
        let _moduleTypeMap = {
          attendance: ROLE_REPLACE_TYPE.portion, // 学生考勤
          dorm: ROLE_REPLACE_TYPE.portion, // 学生宿舍
          classEvaluation: ROLE_REPLACE_TYPE.portion, // 课堂评价

          honour: ROLE_REPLACE_TYPE.unable, // 学生荣誉
          leave: ROLE_REPLACE_TYPE.unable, // 学生请假

          elective: ROLE_REPLACE_TYPE.optional, // 选修课
          familyCall: ROLE_REPLACE_TYPE.optional, // 亲情通话
          clearPlate: ROLE_REPLACE_TYPE.optional, // 光盘行动
          schedule: ROLE_REPLACE_TYPE.optional, // 班级课表
          afterschool: ROLE_REPLACE_TYPE.optional, // 班级放学
          substitute: ROLE_REPLACE_TYPE.optional, // 调代课
          classRank: ROLE_REPLACE_TYPE.optional, // 班级评比
          flexleave: ROLE_REPLACE_TYPE.optional, // 滞留生托管
          security: ROLE_REPLACE_TYPE.optional, // 校园安全
          vehiclemanage: ROLE_REPLACE_TYPE.optional, // 停车管理
          antibully: ROLE_REPLACE_TYPE.optional // 防欺凌
        }

        setItem(MODULE_ROLE_TYPE, {
          moduleType:
            _moduleTypeMap[this.currentModule] || ROLE_REPLACE_TYPE.all,
          [getHash()]: true
        })
      }
    }
  }
}

// 自定义角色相关
const customClassTitle = '全部班级'
const scheduleTitle = '全校'

// 班主任相关
const headerClassTitle = '我的班级'

// 合并角色相关
const scheduleMine = '我的'

const CLASS_COMMON_COMBINE = [customClassTitle, headerClassTitle]

const SCHEDULE_COMBINE = ['教师课表', '班级课表']

const ELECTIVE_COMBINE = ['行政班', '选修班']

const SUBSTITUT_COMBINE = [scheduleTitle, scheduleMine]

const STUDENT_SIGN_COMBINE = ['签到', '统计']

const FACE_COMBINE = ['全部', '我的']

const ANTIBULLY_COMBINE = ['处理中', '已完成']

const SECURITY_COMBINE = ['全部班级', '我的班级']
const MEAL_COMBINE = ['全部班级', '我的班级']

// 自定义角色校验的名称，管理员属于自定义的一种
const customVerifyTitleList = [customClassTitle, scheduleTitle]

// 班主任角色校验的名称
const headerVerifyTitleList = [headerClassTitle]

// 定义所有的应用
const allModuleMap = {
  classModule: {
    module: '默认的使用最多的组合',
    titleList: CLASS_COMMON_COMBINE
  },
  attendance: {
    module: '学生考勤', // 模块名
    titleList: CLASS_COMMON_COMBINE // 模块下展示的 tab 列表
  },

  leave: {
    module: '学生请假',
    titleList: CLASS_COMMON_COMBINE
  },

  dorm: {
    module: '学生宿舍',
    titleList: CLASS_COMMON_COMBINE,
    teacher: {
      // 包含业务老师的 tab
      title: '我的宿舍', // tab 要展示的名称
      getters: 'curIsDormAdmin', // 是否可以展示该模块对应的 getters
      roleId: LEAVE_ROLE.dormAdmin // Number or Array  角色对应的ID 如果是多角色，最后会特殊处理
    }
  },
  moral: {
    module: '德育考评',
    titleList: CLASS_COMMON_COMBINE,
    teacher: {
      title: '我的考评',
      getters: 'isAblleMoral',
      roleId: [
        LEAVE_ROLE.admin,
        LEAVE_ROLE.customRole,
        LEAVE_ROLE.headmaster,
        LEAVE_ROLE.meTeacher,
        LEAVE_ROLE.teacher
      ]
    }
  },
  classRank: {
    module: '班级评比',
    titleList: CLASS_COMMON_COMBINE,
    teacher: {
      title: '我的评比',
      getters: 'curIsCeTeacher',
      roleId: LEAVE_ROLE.ceTeacher
    }
  },

  honour: {
    module: '学生荣誉',
    titleList: CLASS_COMMON_COMBINE
  },

  familyCall: {
    module: '亲情通话',
    titleList: CLASS_COMMON_COMBINE
  },

  welcome: {
    module: '通知公告',
    titleList: CLASS_COMMON_COMBINE
  },

  classEvaluation: {
    module: '课堂评价',
    titleList: CLASS_COMMON_COMBINE,
    teacher: {
      title: '我的评价',
      getters: 'curIsClassTeacher',
      roleId: LEAVE_ROLE.teacher
    }
  },
  clearPlate: {
    module: '光盘行动',
    titleList: CLASS_COMMON_COMBINE
  },
  schedule: {
    module: '班级课表',
    titleList: SCHEDULE_COMBINE
  },
  elective: {
    module: '选修课',
    titleList: ELECTIVE_COMBINE
  },
  substitute: {
    module: '调代课',
    titleList: SUBSTITUT_COMBINE
  },
  afterschool: {
    module: '班级放学',
    titleList: CLASS_COMMON_COMBINE,
    teacher: {
      title: '我的选修班',
      getters: 'curIsElectiveClassTeacher',
      roleId: LEAVE_ROLE.elecTeacher
    }
  },
  detention: {
    module: '学生留堂',
    titleList: CLASS_COMMON_COMBINE,
    teacher: {
      title: '任课班级',
      getters: 'curIsClassTeacher',
      roleId: LEAVE_ROLE.teacher
    }
  },
  flexleave: {
    module: '滞留生',
    titleList: CLASS_COMMON_COMBINE,
    teacher: {
      title: '我的值日',
      getters: 'curIseTeacher',
      roleId: LEAVE_ROLE.seTeacher
    }
  },
  temperature: {
    module: '体温统计',
    titleList: CLASS_COMMON_COMBINE
  },
  studentSign: {
    module: '学生签到',
    titleList: STUDENT_SIGN_COMBINE
  },
  face: {
    module: '信息录入',
    titleList: FACE_COMBINE
  },
  vehiclemanage: {
    module: '车辆管理',
    titleList: FACE_COMBINE
  },
  antibully: {
    module: '防欺凌',
    titleList: ANTIBULLY_COMBINE
  },
  security: {
    module: '校园安全',
    titleList: SECURITY_COMBINE,
    teacher: {
      title: '我的班级',
      getters: 'curIsSecurityManager',
      roleId: [LEAVE_ROLE.securityManager, LEAVE_ROLE.securityPolicer]
    }
  },
  meal: {
    module: '学生用餐',
    titleList: MEAL_COMBINE
  }
}
// 自定义角色 、 管理员、宿舍管理员、班级考评老师
// 所有功能按模块划分
function CreateTab(app, module = 'classModule', isGray) {
  this._init(app, module, isGray)
  let moduleMap = {
    schedule: 'createScheduleTab',
    elective: 'creatElectiveTab',
    substitute: 'createSubstituteTab',
    studentSign: 'createStudentSignTab',
    face: 'createFaceTab',
    vehiclemanage: 'createVehicleTab',
    antibully: 'createBullyTab',
    security: 'createSafetyTab'
  }
  if (moduleMap[module]) {
    this[moduleMap[module]]()
    return
  }
  this.createCommonTab()
}
/* eslint-disable space-before-function-paren */
CreateTab.prototype._init = function (app, module, isGray) {
  this.app = app
  this.module = module
  if (module === 'leave') {
    if (isGray) {
      allModuleMap[module].teacher = {
        title: '任课班级',
        getters: 'curIsClassTeacher',
        roleId: LEAVE_ROLE.teacher
      }
    }
  }
  this.curModule = allModuleMap[module]
  this.commonTabList = []
  this.teacherTabList = []
}
CreateTab.prototype.getSingleTabMap = function (roleId, title) {
  return {
    id: roleId,
    name: title
  }
}
// 通用
CreateTab.prototype.createCommonTab = function () {
  this.createCustomTab()
  this.createHeaderTab()
  this.createTeacherTab()
}
// 通用-自定义角色
CreateTab.prototype.createCustomTab = function () {
  let { curIsAdmin, curIsCustomRole } = this.app

  // 自定义角色
  let customTitle = findSameElement(
    this.curModule.titleList,
    customVerifyTitleList
  )
  if (customTitle) {
    if (curIsAdmin || curIsCustomRole) {
      let roleId = LEAVE_ROLE.customRole
      if (curIsAdmin) {
        roleId = LEAVE_ROLE.admin
      }
      this.commonTabList.push(this.getSingleTabMap(roleId, customTitle))
    }
  }
}
// 通用-班主任
CreateTab.prototype.createHeaderTab = function () {
  let { curIsCampusHeadmaster } = this.app
  let headerTitle = findSameElement(
    this.curModule.titleList,
    headerVerifyTitleList
  )
  if (headerTitle) {
    if (curIsCampusHeadmaster) {
      let roleId = LEAVE_ROLE.headmaster
      this.commonTabList.push(this.getSingleTabMap(roleId, headerTitle))
    }
  }
}
// 通用-业务老师
CreateTab.prototype.createTeacherTab = function () {
  let curTeacher = this.curModule.teacher
  if (curTeacher && this.app[curTeacher.getters]) {
    let teacherMap = {
      moral: 'createMoralEvaTeacherTab' // 德育
    }
    if (teacherMap[this.module]) {
      this[teacherMap[this.module]]()
      return
    }
    this.teacherTabList.push(
      this.getSingleTabMap(curTeacher.roleId, curTeacher.title)
    )
  }
}

// 通用-业务老师-特殊德育
CreateTab.prototype.createMoralEvaTeacherTab = function () {
  let { curIsAdmin, curIsCampusHeadmaster, curIsClassTeacher, curIsMeTeacher } =
    this.app

  let _roleId = []
  curIsAdmin && _roleId.push(LEAVE_ROLE.admin)
  curIsCampusHeadmaster && _roleId.push(LEAVE_ROLE.headmaster)
  curIsMeTeacher && _roleId.push(LEAVE_ROLE.meTeacher)
  curIsClassTeacher && _roleId.push(LEAVE_ROLE.teacher)

  // 如果为单角色 防止 ID 重复，对角色列表进行处理
  if (_roleId.length === 1) {
    _roleId = [_roleId[0], _roleId[0]]
  }
  this.teacherTabList.push(
    this.getSingleTabMap(String(_roleId), this.curModule.teacher.title)
  )
}

// 班级课表 班级课表特殊的地方在于角色的合并
CreateTab.prototype.createScheduleTab = function () {
  let {
    curIsAdmin,
    curIsCustomRole,
    curIsCampusHeadmaster,
    curIsClassTeacher
  } = this.app
  let _adminList = []
  let _otherList = []

  // 管理员
  curIsAdmin && _adminList.push(LEAVE_ROLE.admin)

  // 其他
  curIsCustomRole && _otherList.push(LEAVE_ROLE.customRole)
  curIsCampusHeadmaster && _otherList.push(LEAVE_ROLE.headmaster)
  curIsClassTeacher && _otherList.push(LEAVE_ROLE.teacher)

  // 教师课表
  let _teacherRole = ''
  if (_adminList.length) {
    _teacherRole = _adminList[0]
  } else {
    _teacherRole = String(_otherList)
  }
  this.commonTabList.push(
    this.getSingleTabMap(_teacherRole, SCHEDULE_COMBINE[0])
  )

  // 班级课表
  this.commonTabList.push(
    this.getSingleTabMap(
      String([..._adminList, ..._otherList]),
      SCHEDULE_COMBINE[1]
    )
  )
}
// 学生签到 比较特殊,不区分对应角色的tab，也就是老师组的所有角色都拥有两条tab
CreateTab.prototype.createStudentSignTab = function () {
  let { roleIdList } = this.app
  this.commonTabList.push(
    this.getSingleTabMap(String(roleIdList), STUDENT_SIGN_COMBINE[0])
  )
  this.commonTabList.push(
    this.getSingleTabMap(
      String([...roleIdList, ...roleIdList]),
      STUDENT_SIGN_COMBINE[1]
    )
  )
}
// 选修课、特殊之处： tab 传递的是角色列表，后端会做筛选
// 而且 ID 还有可能重复，所以到具体的页面去赋值
CreateTab.prototype.creatElectiveTab = function () {
  let { curIsAdmin, curIsCustomRole, curIsCampusHeadmaster } = this.app
  if (curIsAdmin || curIsCustomRole || curIsCampusHeadmaster) {
    this.commonTabList.push(this.getSingleTabMap(1, ELECTIVE_COMBINE[0]))
  }

  if (this.app.roleIdList.length) {
    this.commonTabList.push(this.getSingleTabMap(2, ELECTIVE_COMBINE[1]))
  }
}
// 调代课、特殊之处： 我的是机构内所有成员
CreateTab.prototype.createSubstituteTab = function () {
  this.createCustomTab()
  // 如果为单角色 防止 ID 重复，对角色列表进行处理
  let temp = this.app.roleIdList
  if (temp.length === 1) {
    temp = [this.app.roleIdList[0], this.app.roleIdList[0]]
  }
  // 我的
  this.commonTabList.push(this.getSingleTabMap(String([temp]), scheduleMine))
}
// 人脸录入
// case1: 管理员、班主任 全部我的
// case2: 普通老师 我的
// case3: 家长 我的
CreateTab.prototype.createFaceTab = function () {
  let { curIsAdmin, curIsCampusHeadmaster } = this.app
  if (curIsAdmin) {
    this.commonTabList.push({
      id: LEAVE_ROLE.admin,
      name: FACE_COMBINE[0],
      value: 0
    })
    this.commonTabList.push({
      id: String([LEAVE_ROLE.admin, LEAVE_ROLE.admin]),
      name: FACE_COMBINE[1],
      value: 1
    })
  } else if (curIsCampusHeadmaster) {
    this.commonTabList.push({
      id: LEAVE_ROLE.headmaster,
      name: FACE_COMBINE[0],
      value: 0
    })
    this.commonTabList.push({
      id: String([LEAVE_ROLE.headmaster, LEAVE_ROLE.headmaster]),
      name: FACE_COMBINE[1],
      value: 1
    })
  } else {
    this.commonTabList.push({
      id: 1,
      name: FACE_COMBINE[0],
      value: this.app.roleIdList.join(','),
      roleIdList: this.app.roleIdList
    })
  }
}
CreateTab.prototype.createVehicleTab = function () {
  let { curIsAdmin, curIsCustomRole, curIsCampusHeadmaster } = this.app
  if (curIsAdmin) {
    this.commonTabList.push(
      this.getSingleTabMap(LEAVE_ROLE.admin, FACE_COMBINE[0])
    )
  }

  if (curIsCustomRole || curIsCampusHeadmaster) {
    this.commonTabList.push(
      this.getSingleTabMap(LEAVE_ROLE.headmaster, FACE_COMBINE[1])
    )
  }
}
CreateTab.prototype.createBullyTab = function () {
  // 管理员 自定义管理员 班主任 区域负责人 出警人可以看到处理中 只有出警人可以处理防欺凌事件
  let {
    curIsAdmin,
    curIsCampusHeadmaster,
    curIsSecurityPolicer,
    curIsSecurityManager
  } = this.app
  if (curIsAdmin || curIsSecurityPolicer || curIsSecurityManager) {
    this.commonTabList.push(this.getSingleTabMap(0, ANTIBULLY_COMBINE[0]))
  }

  if (
    curIsAdmin ||
    curIsCampusHeadmaster ||
    curIsSecurityManager ||
    curIsSecurityPolicer
  ) {
    this.commonTabList.push(this.getSingleTabMap(1, ANTIBULLY_COMBINE[1]))
  }
}
CreateTab.prototype.createSafetyTab = function () {
  // 管理员 自定义管理员 班主任 区域负责人 出警人可以看到处理中 只有出警人可以处理防欺凌事件
  let {
    curIsAdmin,
    curIsCampusHeadmaster,
    curIsSecurityPolicer,
    curIsSecurityManager
  } = this.app
  if (curIsAdmin || curIsSecurityPolicer || curIsSecurityManager) {
    this.commonTabList.push(this.getSingleTabMap(0, SECURITY_COMBINE[0]))
  }

  if (
    curIsAdmin ||
    curIsCampusHeadmaster ||
    curIsSecurityManager ||
    curIsSecurityPolicer
  ) {
    this.commonTabList.push(this.getSingleTabMap(1, SECURITY_COMBINE[1]))
  }
}
// 通用-获取列表
CreateTab.prototype.getTabList = function () {
  return [...this.commonTabList, ...this.teacherTabList]
}

function findSameElement(sourceList = [], verifyList = []) {
  for (let item of verifyList) {
    let ele = sourceList.find(v => item === v)
    if (ele) {
      return ele
    }
  }
  return ''
}
